import { Permissions } from 'utils/constants/permissions';

type Path = {
    code: string;
    path: string;
    permission: Permissions;
    dataQa?: string;
};

export const reports: Path[] = [
    {
        code: 'monthlyActsSummary',
        path: '/new/admin/acts-summary-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'monthlyActs',
        path: '/new/admin/acts-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'invoiceManual',
        path: '/new/admin/manual-charges-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'overflow',
        path: '/new/admin/overflow-report/',
        permission: Permissions.ViewAdminSection,
    },
    {
        code: 'campaignsReport',
        path: '/new/admin/campaigns-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'monthlyIncomeExpense',
        path: '/new/admin/income-expense-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'billingFunnel',
        path: '/new/admin/billing-funnel-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'efficiency',
        path: '/new/admin/efficiency-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'accountStatistics',
        path: '/new/admin/account-statistics-report/',
        permission: Permissions.ViewAdminFullMenu,
    },
    {
        code: 'directReport',
        path: '/new/admin/yandex-direct-report/',
        permission: Permissions.ViewAdminSection,
    },
];

export const moderation: Path[] = [
    {
        code: 'moderationList',
        path: '/new/admin/moderation-list/',
        permission: Permissions.ViewModeration,
    },
    {
        code: 'moderationReasonsList',
        path: '/new/admin/moderation-reasons-list/',
        permission: Permissions.ViewModeration,
    },
    {
        code: 'bannerInfo',
        path: '/new/admin/banner-info/',
        permission: Permissions.ViewModeration,
    },
];

const aliases: Path[] = [
    {
        code: 'invoices',
        path: '/new/admin/invoices/',
        permission: Permissions.ViewAdminSection,
        dataQa: 'admin_tab_invoice_backend',
    },
    {
        code: 'users',
        path: '/new/admin/users/',
        permission: Permissions.ViewAdminSection,
        dataQa: 'admin_tab_users_backend',
    },
    {
        code: 'payers',
        path: '/new/admin/payers',
        permission: Permissions.ViewAdminFullMenu,
        dataQa: 'admin_tab_payer_backend',
    },
    {
        code: 'crm',
        path: '/new/admin/crm/',
        permission: Permissions.ViewAdminFullMenu,
        dataQa: 'admin_tab_crm',
    },
    {
        code: 'translations',
        path: '/new/admin/translations/',
        permission: Permissions.ViewAdminFullMenu,
        dataQa: 'admin_tab_translations',
    },
    {
        code: 'editingActs',
        path: '/new/admin/editing-acts/',
        permission: Permissions.ViewAdminFullMenu,
        dataQa: 'admin_tab_editing_acts',
    },
    {
        code: 'promoCodes',
        path: '/new/admin/promo-codes/',
        permission: Permissions.ViewAdminFullMenu,
        dataQa: 'admin_tab_promo_codes',
    },
];

export default aliases;
